export const flagshipABContentNotFound = (testName, variationName) => ({
  type: 'Flagship AB Test Content Not Found',
  data: {
    testName,
    variationName,
  },
});
